export default __webpack_public_path__ + "static/media/info-icon.97b6536b.svg";